import { render, staticRenderFns } from "./switchRole.vue?vue&type=template&id=752f0c3e&"
import script from "./switchRole.vue?vue&type=script&lang=js&"
export * from "./switchRole.vue?vue&type=script&lang=js&"
import style0 from "./switchRole.vue?vue&type=style&index=0&id=752f0c3e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports